import {Collections} from '../interfaces/collections';
import {PROJECT_PERMISSIONS} from './project-permissions';

export const USER_PROJECT_PERMISSIONS_MODULE = {
  id: Collections.UserProjectPermissions,
  ...PROJECT_PERMISSIONS
}
